/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style10 = require("antd/lib/icon/style");

var _icon = require("antd/lib/icon");

var _icon2 = _interopRequireDefault(_icon);

var _style11 = require("antd/lib/button/style");

var _button = require("antd/lib/button");

var _button2 = _interopRequireDefault(_button);

var _style12 = require("antd/lib/modal/style");

var _modal = require("antd/lib/modal");

var _modal2 = _interopRequireDefault(_modal);

var _style13 = require("antd/lib/upload/style");

var _upload = require("antd/lib/upload");

var _upload2 = _interopRequireDefault(_upload);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _style14 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _style15 = require("antd/lib/input/style");

var _input = require("antd/lib/input");

var _input2 = _interopRequireDefault(_input);

var _style16 = require("antd/lib/radio/style");

var _radio = require("antd/lib/radio");

var _radio2 = _interopRequireDefault(_radio);

var _style17 = require("antd/lib/select/style");

var _select = require("antd/lib/select");

var _select2 = _interopRequireDefault(_select);

var _style18 = require("antd/lib/form/style");

var _form = require("antd/lib/form");

var _form2 = _interopRequireDefault(_form);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _config = require("util/config");

var _tool = require("util/tool");

require("./index.less");

var _premissionAuth = require("util/premissionAuth");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var Option = _select2.default.Option;
var RadioGroup = _radio2.default.Group;
var TextArea = _input2.default.TextArea;

var _ref2 = (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(_icon2.default, {
  type: "plus"
}), (0, _jsx3.default)("div", {
  className: "ant-upload-text"
}, void 0, "\u4E0A\u4F20\u56FE\u7247"));

var _ref3 = (0, _jsx3.default)(_input2.default, {});

var _ref4 = (0, _jsx3.default)(_input2.default, {});

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.handleCancel = function () {
      return _this.setState({ previewVisible: false });
    };

    _this.handlePreview = function (file) {
      _this.setState({
        previewImage: file.url || file.thumbUrl,
        previewVisible: true
      });
    };

    _this.handleChange = function (_ref) {
      var fileList = _ref.fileList;

      _this.setState({ fileList: fileList });
      if (fileList.length && fileList[0].response) {
        var res = fileList[0].response;
        if (res) {
          if (res.status == 1) {
            _this.props.initInfo.pictureId = res.data[0];
          } else {
            _message2.default.error("图片上传失败");
            _this.setState({ fileList: [] });
          }
        }
      }
    };

    _this.state = (0, _extends3.default)({
      equipment: [],
      targetKeys: []
    }, _this.props, _this.props.initInfo.imgObj);
    console.log(_this.props);
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      (0, _tool.http)(_config.apiJson.getDeviceTypeList).then(function (res) {
        // console.log(res)
        var equip = [];
        for (var item in res) {
          equip.push({
            equipmentType: item,
            equipmentNum: "" + res[item]
          });
        }
        _this2.setState({
          equipment: equip
        });
      });
      (0, _tool.http)(_config.apiJson.getAllPart).then(function (req) {
        _this2.setState({
          list: req.map(function (mp) {
            return {
              key: mp.id,
              title: mp.partName,
              description: mp.partName
            };
          })
        });
        _this2.props.initInfo.partInfoVoList ? _this2.setState({
          targetKeys: _this2.props.initInfo.partInfoVoList.map(function (mp) {
            return mp.id;
          })
        }) : "";
        console.log(_this2.state.targetKeys, 'targetKeystargetKeys');
      });
      // 拉取设备类型
    }
  }, {
    key: "onRemove",

    // 选中
    // handleChangeSelect = (nextTargetKeys, direction, moveKeys) => {
    //   this.setState({ targetKeys: nextTargetKeys });
    //   this.props.initInfo.partList =
    //     nextTargetKeys.length == 0 ? "" : nextTargetKeys;
    // };
    // // 赋值
    // handleSelectChangeBj = (sourceSelectedKeys, targetSelectedKeys) => {
    //   this.setState({
    //     selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys]
    //   });
    // };
    value: function onRemove(file) {
      if (file.status === 'removed') {
        this.setState({
          fileList: []
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (!this.state.fileList.length) {
        var file = this.props.initInfo.imgObj.length;
        if (!file) {
          // this.handlePreview(this.props.initInfo.imgObj)
          this.handleChange(this.props.initInfo.imgObj);
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }, {
    key: "getModel",
    value: function getModel(val) {
      var _this3 = this;

      this.state.equipment.forEach(function (item) {
        if (item.equipmentType === val) {
          // this.state.initInfo.accessDeviceTypeName = val;
          _this3.state.initInfo.accessDeviceType = item.equipmentNum;
          _this3.setState({
            initInfo: _this3.state.initInfo
          });
        }
      });
    }
  }, {
    key: "getType",
    value: function getType(val) {
      var _this4 = this;

      this.state.equipment.forEach(function (item) {
        if (item.equipmentNum === val) {
          _this4.state.initInfo.accessDeviceType = val;
          _this4.state.initInfo.accessDeviceTypeName = item.equipmentType;
          _this4.setState({
            initInfo: _this4.state.initInfo
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          form = _props.form,
          initInfo = _props.initInfo,
          params = _props.params,
          deviceTypes = _props.deviceTypes;
      var getFieldDecorator = form.getFieldDecorator;
      var _state = this.state,
          previewVisible = _state.previewVisible,
          previewImage = _state.previewImage,
          fileList = _state.fileList;

      var formItemCol = {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 1 }
      };
      var token = localStorage.getItem("token");
      var ctoken = (0, _premissionAuth.getToken)();

      var headers = {
        Token: ctoken ? ctoken : token
      };

      var uploadButton = _ref2;
      var formObj = {
        businessType: "PRODUCT_IMAGE"
      };

      var options = [];

      deviceTypes.map(function (item) {
        var tpl = (0, _jsx3.default)(Option, {
          value: item.deviceTypeNumber + ""
        }, item.deviceTypeNumber, item.deviceTypeName);
        options.push(tpl);
      });

      // 部件选择
      return (0, _jsx3.default)("div", {
        className: "cp-form"
      }, void 0, (0, _jsx3.default)(_form2.default, {
        onSubmit: this.props.handleSubmit.bind(this)
      }, void 0, _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u4EA7\u54C1\u540D\u79F0" }, formItemCol),
        getFieldDecorator("name", {
          rules: [{ required: true, message: "产品名称不能为空" }],
          initialValue: initInfo.name
        })(_ref3)
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u8BBE\u5907\u5382\u5546" }, formItemCol),
        getFieldDecorator("factoryName", {
          rules: [{ required: true, message: "设备厂商不能为空" }],
          initialValue: initInfo.factoryName
        })(_ref4)
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u8BBE\u5907\u7C7B\u578B" }, formItemCol),
        getFieldDecorator("accessDeviceTypeName", {
          rules: [{ required: true, message: "设备类型不能为空" }],
          initialValue: initInfo.accessDeviceTypeName
        })((0, _jsx3.default)(_select2.default, {
          onChange: this.getModel.bind(this)
        }, void 0, this.state.equipment.map(function (item, index) {
          return (0, _jsx3.default)(Option, {
            value: item.equipmentType
          }, index, item.equipmentType);
        })))
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u8BBE\u5907\u578B\u53F7" }, formItemCol),
        getFieldDecorator("accessDeviceType", {
          rules: [{ required: true, message: "设备型号不能为空" }],
          initialValue: initInfo.accessDeviceType
        })((0, _jsx3.default)(_select2.default, {
          disabled: true
        }, void 0, this.state.equipment.map(function (item, index) {
          return (0, _jsx3.default)(Option, {
            value: item.equipmentNum
          }, index, item.equipmentNum);
        })))
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({ label: "\u8BBE\u5907\u56FE\u7247" }, formItemCol),
        getFieldDecorator("pictureId", {
          rules: [
          // { required: !initInfo.isEdit, message: "图片不能为空" }
          { required: true, message: "图片不能为空" }],
          initialValue: "" + initInfo.pictureId
        })((0, _jsx3.default)("div", {
          className: "clearfix"
        }, void 0, (0, _jsx3.default)(_upload2.default, {
          action: _config.target + _config.apiJson.upload,
          listType: "picture-card",
          fileList: fileList,
          onPreview: this.handlePreview,
          onChange: this.handleChange,
          onRemove: this.onRemove.bind(this),
          data: formObj,
          headers: headers
        }, void 0, fileList.length >= 1 ? null : uploadButton), (0, _jsx3.default)(_modal2.default, {
          visible: previewVisible,
          footer: null,
          onCancel: this.handleCancel
        }, void 0, (0, _jsx3.default)("img", {
          alt: "example",
          style: { width: "100%" },
          src: previewImage
        }))))
      ), (0, _jsx3.default)(FormItem, {
        label: "\u4EA7\u54C1\u7B80\u4ECB",
        labelCol: { span: 4 },
        wrapperCol: { span: 19, offset: 1 }
      }, void 0, getFieldDecorator("remark", {
        rules: [{ required: false }],
        initialValue: initInfo.remark || ""
      })((0, _jsx3.default)(TextArea, {
        style: { height: "124px" },
        placeholder: "\u7F16\u5199\u8BE5\u4EA7\u54C1\u7684\u7B80\u8981\u8BF4\u660E\uFF0C\u5982\u4EA7\u54C1\u7CFB\u5217\u7279\u70B9\uFF0C\u4E3B\u8981\u51FA\u8D27\u5BF9\u8C61\u7B49\u4FE1\u606F"
      }))), (0, _jsx3.default)(FormItem, {
        wrapperCol: { span: 19, offset: 5 }
      }, void 0, (0, _jsx3.default)("div", {
        className: "btn-group"
      }, void 0, (0, _jsx3.default)(_button2.default, {
        type: "default",
        onClick: this.props.cancleClick.bind(this)
      }, void 0, "\u53D6\u6D88"), (0, _jsx3.default)(_button2.default, {
        type: "primary",
        htmlType: "submit",
        disabled: initInfo.lock
      }, void 0, "\u786E\u5B9A")))));
    }
  }]);
  return Main;
}(_react.Component);

var Fromtpl = _form2.default.create()((0, _reactRouter.withRouter)(Main));

exports.default = Fromtpl;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/product/equipment/form/index.jsx
// module id = 1055
// module chunks = 0